import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./receiptDesign.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import { ToastContainer, toast } from 'react-toastify';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import AddReceipt from 'LIBRARY/Components/Settings/ReceiptDesign/AddReceipt/AddReceipt';
import Pagination from 'react-js-pagination';
import { getLibraryAccessDetails, setAssignedInstitute } from 'LIBRARY/Actions/AdminDetailsAction.js';
import { connect } from 'react-redux';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

class ReceiptDesign extends Component {

    constructor(props) {
        super(props);
        this.state = {
            LoadingReceiptList: true,
            receiptList: {},
            totalReceipts: '',
            sequenceReceiptList: {},

            // variables for filters
            filterTitle: '',
            filterType: '',

            // VARIABLES TO SELECT RECEIPTS
            selectedReceiptIds: [],

            // VARIABLES TO MARK DESIGN AS DEFAULT
            markReceiptAsDefault: false,
            markingDefault: false,
            confirmationText: '',
            confirmationTextWarning: '',

            // VARIABLES TO DELETE RECEIPTS
            deleteReceipt: false,
            deletingReceipt: false,

            // VARIABLES TO ADD / UPDATE RECEIPT
            addReceipt: false,
            isReceiptEdit: false,
            receiptUniqueId: '',
            receiptTitle: '',
            receiptDescription: '',
            receiptType: '',
            markAsDefault: 'no',
            receiptDesign: '',

            offset: 0,
            pageIndex: 1,
            limit: 10,

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        }
    }

    componentDidMount() {
        this.apiCallToReceiptDesignList();
    }

    // API CALL TO GET RECEIPT DATA LIST
    apiCallToReceiptDesignList = async () => {
        this.setState({
            LoadingReceiptList: true
        });

        let requestData = {
            "iid": config.institute_id,
            "searchtitle": this.state.filterTitle.trim(),
            "searchType": this.state.filterType,
            "limit": this.state.limit,
            "page_index": this.state.pageIndex,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryReceipt',
            requestData,
            "/api/library/libraryReceiptDesign.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToReceiptDesignList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        receiptList: apiResult.data,
                        sequenceReceiptList: apiResult.sortedIdArray,
                        totalReceipts: apiResult.totalCount,
                        LoadingReceiptList: false
                    })
                }
                else {
                    this.setState({
                        receiptList: {},
                    })
                }
            } else {
                this.setState({
                    receiptList: {},
                })
            }
        }
    }

    // API CALL METHOD TO MARK AS DEFAULT
    apiCallToMarkAsDefault = async () => {
        this.setState({
            markingDefault: true
        });

        let requestData = {
            'iid': config.institute_id,
            'uniqueId': this.state.selectedReceiptIds.toString(),
            'receiptType': this.state.receiptList[this.state.selectedReceiptIds.toString()].receiptType,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'libraryMarkAsDefaultReceiptDesign',
            requestData,
            '/api/library/libraryReceiptDesign.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToMarkAsDefault();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    this.setState({
                        markingDefault: false,
                        selectedReceiptIds: []
                    });

                    setTimeout(() => {
                        // METHOD CALLED TO GET RECEIPT DETAILS
                        this.apiCallToReceiptDesignList();
                    }, 3000);

                    this.closeMarkDefault();
                } else {
                    this.setState({
                        markingDefault: false
                    });

                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                this.setState({
                    markingDefault: false,
                });

                toast.error('Something went wrong while marking receipt as default. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // METHOD TO GET RECEIPT BY NAME
    getReceiptByTitle = (e) => {
        if (e.charCode == 13) {
            this.setState({
                pageIndex: 1,
                offset: 0,
                filterApplied: true
            }, () => {
                // METHOD CALLED TO GET RECEIPT DETAILS
                this.apiCallToReceiptDesignList();
            });
        }
    }

    // METHOD TO SELECT ALL RECEIPTS
    selectAllReceipts = (e) => {
        let selectedReceiptSet = new Set();

        if (e.target.checked) {
            if (Object.keys(this.state.receiptList).length > 0) {
                Object.keys(this.state.receiptList).map(receiptId => {
                    selectedReceiptSet.add(receiptId);
                });
            }
        } else {
            if (Object.keys(this.state.receiptList).length > 0) {
                Object.keys(this.state.receiptList).map(receiptId => {
                    selectedReceiptSet.delete(receiptId);
                });
            }
        }

        this.setState({
            selectedReceiptIds: Array.from(selectedReceiptSet)
        });
    }

    // METHOD TO SELECT SINGLE RECEIPT
    selectSingleReceipt = (receiptId) => {
        let selectedReceiptIds = this.state.selectedReceiptIds;

        if (selectedReceiptIds.includes(receiptId)) {
            selectedReceiptIds = selectedReceiptIds.filter(id => id != receiptId);
        } else {
            selectedReceiptIds.push(receiptId);
        }

        this.setState({
            selectedReceiptIds
        });
    }

    // METHOD TO GET MARK DEFAULT DETAILS
    getMarkDefaultDetails = () => {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {

            if (this.state.selectedReceiptIds.length > 1) {
                toast.warn('Please select only one receipt to mark as default.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                this.setState({
                    markReceiptAsDefault: true
                });
            }
        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO GET CONFIRMATION TEXT
    getConfirmationText = (e) => {
        this.setState({
            confirmationText: e.target.value
        });

        if (e.target.value != 'YES') {
            this.setState({
                confirmationTextWarning: 'Please enter YES to mark receipt as default.'
            });
        } else {
            this.setState({
                confirmationTextWarning: ''
            });
        }
    }

    // METHOD TO RETURN MARK DEFAULT
    returnMarkDefault = () => {
        return (
            <div className={this.state.markReceiptAsDefault ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered markDefault-dialog">
                    <div className="modal-content markDefault-content">
                        <div className="modal-header markDefault-header">
                            <p style={{ textTransform: "none", fontSize: 20, color: '#FFF', width: '98%', textAlign: 'center' }}>Mark as Default</p>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" onClick={() => this.closeMarkDefault()} />
                        </div>
                        <div className="modal-body markDefault-body">
                            <p style={{ fontSize: 13, color: '#545454' }}>Upon setting this receipt as a default, the system will automatically set its design as a default design and action will affect on both of them.</p>
                            <p style={{ fontSize: 13, color: '#545454', marginTop: 15 }}>If you want to mark this as Default, type <span style={{ fontWeight: 'bold' }}>YES</span> in block / capital letters in below input text for confirmation.</p>
                            <input
                                type="text"
                                className="form-control confirmationInput"
                                placeholder="Please type YES"
                                value={this.state.confirmationText}
                                onChange={(e) => this.getConfirmationText(e)}
                                maxLength={3}
                                style={{ marginTop: 15 }}
                            />
                            <p className="text-danger" style={{ fontSize: 13 }}>{this.state.confirmationTextWarning}</p>
                        </div>
                        <div className="modal-footer markDefault-footer">
                            {
                                this.state.markingDefault &&
                                <Spinner />
                            }
                            <p className="markDefaultButton" style={{ opacity: (this.state.markingDefault || this.state.confirmationText != 'YES') ? 0.5 : 1 }} onClick={(e) => { (this.state.markingDefault || this.state.confirmationText != 'YES') ? e.preventDefault() : this.apiCallToMarkAsDefault() }}>Yes</p>
                            <p className="cancelDefaultButton" style={{ opacity: this.state.markingDefault ? 0.5 : 1 }} onClick={(e) => this.state.markingDefault ? e.preventDefault() : this.closeMarkDefault()}>No</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE MARK DEFAULT
    closeMarkDefault = () => {
        this.setState({
            markReceiptAsDefault: false,
            markingDefault: false,
            confirmationText: '',
            confirmationTextWarning: ''
        });
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET RECEIPTS DETAILS
            this.apiCallToReceiptDesignList();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
        }, () => {
            // METHOD CALLED TO GET RECEIPTS DETAILS
            this.apiCallToReceiptDesignList();
        });
    }

    // METHOD TO CLOSE ADD RECEIPT
    closeAddReceipt = () => {
        this.setState({
            addReceipt: false,
            isReceiptEdit: false,
            receiptUniqueId: '',
            receiptTitle: '',
            receiptDescription: '',
            receiptType: '',
            markAsDefault: false,
            receiptDesign: '',
        }, () => {
            // METHOD CALLED TO GET RECEIPT DETAILS
            this.apiCallToReceiptDesignList();
        });
    }

    // METHOD TO GET UPDATE RECEIPT DETAILS
    getReceiptUpdateDetails = (receipt) => {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {

            this.setState({
                addReceipt: true,
                isReceiptEdit: true,
                receiptUniqueId: receipt.uniqueId,
                receiptTitle: receipt.title,
                receiptDescription: receipt.description,
                receiptType: receipt.receiptType,
                markAsDefault: (receipt.isDefault == undefined || receipt.isDefault == '') ? false : (receipt.isDefault == 'yes' ? true : false),
                receiptDesign: receipt.receipt_design == undefined ? '' : receipt.receipt_design,
            });

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // API CALL METHOD TO DELETE RECEIPT
    apiCallToDeleteReceipt = async () => {
        this.setState({
            deletingReceipt: true
        });

        let requestData = {
            'iid': config.institute_id,
            'updatedBy': config.faculty_id,
            'unique_ids': this.state.selectedReceiptIds,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'deleteLibraryReceipt',
            requestData,
            '/api/library/libraryReceiptDesign.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteReceipt();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    this.setState({
                        deletingReceipt: false,
                        selectedReceiptIds: []
                    });

                    // if ((this.state.pageIndex * this.state.limit) <= this.state.totalReceipts) {
                    //     let receiptList = this.state.receiptList;
                    //     let sequenceReceiptList = this.state.sequenceReceiptList;
                    //     let totalReceipts = this.state.totalReceipts;

                    //     apiResult.deletedMemberIds.map(receiptId => {
                    //         delete receiptList[receiptId];
                    //         sequenceReceiptList = sequenceReceiptList.filter(id => id != receiptId);
                    //     });

                    //     totalReceipts = totalReceipts - (apiResult.deletedMemberIds.length);

                    //     this.setState({
                    //         receiptList,
                    //         sequenceReceiptList,
                    //         totalReceipts
                    //     });
                    // } else {
                    // METHOD CALLED TO GET RECEIPT DETAILS
                    this.apiCallToReceiptDesignList();
                    // }

                    this.closeDeleteReceipt();
                } else {
                    this.setState({
                        deletingReceipt: false
                    });

                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                this.setState({
                    deletingReceipt: false,
                });

                toast.error('Something went wrong while deleting receipt details. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // METHOD TO CLOSE DELETE RECEIPT
    closeDeleteReceipt = () => {
        this.setState({
            deleteReceipt: false,
            deletingReceipt: false
        });
    }

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    checkAddReceipts = () => {
        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            this.setState({
                addReceipt: true,
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = () => {

        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {
            this.setState({
                deleteReceipt: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {

        return (
            <>
                <RoutingMenu activeScreen="receiptDesign" />
                <div className="libraryComponents-container">
                    {
                        this.state.addReceipt ?
                            <AddReceipt
                                isReceiptEdit={this.state.isReceiptEdit}
                                receiptUniqueId={this.state.receiptUniqueId}
                                receiptTitle={this.state.receiptTitle}
                                receiptDescription={this.state.receiptDescription}
                                receiptType={this.state.receiptType}
                                markAsDefault={this.state.markAsDefault}
                                receiptDesign={this.state.receiptDesign}
                                closeAddReceipt={this.closeAddReceipt}
                            />
                            :
                            <>
                                <div className="pl-0 row col-md-12">
                                    <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => this.props.closeReceiptDesign()} >
                                        <FontAwesomeIcon className="" icon={["fa", "angle-left"]} />
                                    </button>
                                    &nbsp;
                                    <div className="mt-1">
                                        <h3 style={{ fontSize: "28px" }}>Receipt Design</h3>
                                    </div>
                                </div>
                                <div>
                                    <div className="pl-0 pt-4 col-md-12">
                                        <div className="row d-flex justify-content-between pb-2">
                                            <span className="col-md-8 pl-0">
                                                <div className="d-flex">
                                                    <div className="col-md-4">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search by Receipt Name"
                                                            value={this.state.filterTitle}
                                                            onChange={(e) => this.setState({ filterTitle: e.target.value })}
                                                            onKeyPress={(e) => this.getReceiptByTitle(e)}

                                                        />
                                                        <p className="d-flex justify-content-end" style={{ color: '#7A7A7A', fontSize: '10px' }}>Press enter to search.</p>
                                                    </div>
                                                    <div className='col-md-4 pl-0 pr-1'>
                                                        <select
                                                            className="form-control"
                                                            value={this.state.filterType}
                                                            onChange={(e) => { this.setState({ filterType: e.target.value, pageIndex: 1, offset: 0 }, () => { this.apiCallToReceiptDesignList(); }) }}

                                                        >
                                                            <option value="">Receipt Type</option>
                                                            <option value="issue">Issue</option>
                                                            <option value="return">Return</option>
                                                            <option value="renew">Renew</option>
                                                            <option value="fine">Fine</option>
                                                            <option value="noDue">No Due</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </span>
                                            <div>
                                                <button type="button" onClick={() => this.checkAddReceipts()} className="btn btn-primary">
                                                    <FontAwesomeIcon icon={["fa", "plus"]} /> &nbsp;
                                                    Add New Receipt Design
                                                </button>
                                            </div>
                                        </div>

                                        <div className="receiptList pt-2 col-md-12">
                                            {
                                                this.state.LoadingReceiptList
                                                    ?
                                                    <div className='align-center bold text-black-50'>
                                                        Loading Receipts. . .&nbsp;
                                                        <FontAwesomeIcon icon={['fas', 'circle-notch']} size='lg' className='rotate' />
                                                    </div>
                                                    :
                                                    Object.keys(this.state.receiptList).length == 0
                                                        ?
                                                        <div className=' align-center text-black-50'>
                                                            Receipts details are not yet added.
                                                        </div>
                                                        :
                                                        <>
                                                            <div className='table-responsive' style={{ paddingLeft: '3%', paddingRight: '3%', maxHeight: '50vh', overflowY: 'scroll' }}>
                                                                <table className="table table-responsive-sm rounded-3" style={{ background: '#FFF' }}>
                                                                    <thead className='headingColor' style={{ backgroundColor: "#ffffff", position: 'sticky', top: '-1%' }}>
                                                                        <tr>
                                                                            <th className='p-2 primary-fill printHide'>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={Object.keys(this.state.receiptList).length > 0 && (Object.keys(this.state.receiptList).length == this.state.selectedReceiptIds.length)}
                                                                                    onChange={(e) => this.selectAllReceipts(e)}
                                                                                />
                                                                            </th>
                                                                            <th className='p-2 primary-fill'>Sr. No.</th>
                                                                            <th className='p-2 primary-fill'>Receipt Title</th>
                                                                            <th className='p-2 primary-fill'>Description</th>
                                                                            <th className='p-2 primary-fill'>Receipt Type</th>
                                                                            <th className='p-2 primary-fill'>Last Modified By</th>
                                                                        </tr>
                                                                        {
                                                                            this.state.selectedReceiptIds.length > 0 &&
                                                                            <tr className='active-row'>
                                                                                <th colSpan='6' className='p-0'>
                                                                                    <div className='componentAction-button' style={{ background: '#FFF' }}>
                                                                                        <button
                                                                                            className='btn btn-outline-primary rounded-5 mr-2 p-1 pl-3 pr-3'
                                                                                            title='Click to mark selected receipt as default'
                                                                                            onClick={() => this.getMarkDefaultDetails()}
                                                                                        ><span style={{ fontSize: '12px' }}>Mark as Default</span></button>
                                                                                        <button
                                                                                            className='btn btn-outline-primary rounded-5 p-1 pl-3 pr-3'
                                                                                            title='Click to delete selected receipt'
                                                                                            onClick={() => this.checkDeleteAccess()}
                                                                                        ><span style={{ fontSize: '12px' }}>Delete</span></button>
                                                                                    </div>
                                                                                </th>
                                                                            </tr>
                                                                        }
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            this.state.sequenceReceiptList.map((receiptId, receiptIndex) => {
                                                                                let receipt = this.state.receiptList[receiptId];
                                                                                return (
                                                                                    <tr key={receiptId}>
                                                                                        <td className='p-2'>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={this.state.selectedReceiptIds.includes(receiptId.toString())}
                                                                                                onChange={() => this.selectSingleReceipt(receiptId.toString())}
                                                                                            />
                                                                                        </td>
                                                                                        <td className='p-2'>{this.state.offset + receiptIndex + 1}.</td>
                                                                                        <td className='p-2'>
                                                                                            <span style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }} title="Click to update receipt details" onClick={() => this.getReceiptUpdateDetails(receipt)}>{receipt.title.length > 30 ? receipt.title.substring(0, 30) + '...' : receipt.title}</span>
                                                                                            {
                                                                                                receipt.isDefault == 'yes' &&
                                                                                                <span className="defaultBadge">Default</span>
                                                                                            }
                                                                                        </td>
                                                                                        <td className='p-2' title={receipt.description}>{receipt.description.length > 75 ? receipt.description.substring(0, 75) + '...' : receipt.description}</td>
                                                                                        <td className='p-2 text-capitalize'>{receipt.receiptType == 'noDue' ? 'No Due' : receipt.receiptType}</td>
                                                                                        <td className='p-2' style={{ padding: "5px", cursor: "pointer", color: receiptId == this.state.hoverID ? "#0465AC" : "" }}
                                                                                            onMouseEnter={() => this.setState({ hoverID: receiptId })}
                                                                                            onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                                            onClick={() => this.openActivitySlider(receiptId)}>
                                                                                            {receipt.created_by ? receipt.created_by : '-'}
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </>
                                            }
                                        </div>

                                        {
                                            (!this.state.LoadingReceiptList && this.state.sequenceReceiptList.length > 0) &&
                                            <div className="pl-3 pr-4">
                                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                                    <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                                        <span >Show</span>
                                                        <select
                                                            className="mx-2"
                                                            value={this.state.limit}
                                                            onChange={(e) => this.selectLimit(e)}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={40}>40</option>
                                                            <option value={100}>100</option>
                                                            <option value={250}>250</option>
                                                        </select>
                                                        <span>entries</span>
                                                    </div>
                                                    <div id="paginationContainer">
                                                        <Pagination
                                                            activePage={this.state.pageIndex}
                                                            itemsCountPerPage={this.state.limit}
                                                            totalItemsCount={this.state.totalReceipts}
                                                            pageRangeDisplayed={3}
                                                            onChange={(num) => this.updatePaginationCount(num)}
                                                        />
                                                    </div>
                                                    <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalReceipts} </p>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </>
                    }
                </div>
                <ToastContainer theme="light" />

                {
                    this.returnMarkDefault()
                }

                {
                    this.state.deleteReceipt &&
                    <DeleteModal
                        showModal={this.state.deleteReceipt}
                        visibility={this.closeDeleteReceipt}
                        deleteKey='Receipt'
                        deleteComponent={this.apiCallToDeleteReceipt}
                    />
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["receipt_added", "receipt_updated", "receipt_deleted"]}
                    />
                }
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        assignedInstitute: { ...store.RouteMenuReducer.assignedInstitute },
        assignedIIDArray: { ...store.RouteMenuReducer.assignedIIDArray },
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};


export default connect(mapStateToProps)(ReceiptDesign);